interface ResourceNameProps {
  name: string;
  description: string;
}

export function ResourceName({ name, description }: ResourceNameProps) {
  return (
    <div className="w-1/2">
      <span className="text-lg">{name} </span>
      <div className="opacity-50">{description} </div>
    </div>
  );
}
